import React from 'react';
import { TermsAgreementModal } from './TermsAgreementModal';
import { TermsAgreementGuardProps } from './types';
import { useTermsAgreementGuard } from './useTermsAgreementGuard';
import './TermsAgreementGuard.css';

/**
 * 利用規約同意チェック用ガードコンポーネント
 * ログイン後に利用規約への同意が必要かどうかをチェックし、
 * 必要な場合は同意モーダルを表示する
 */
export const TermsAgreementGuard: React.FC<TermsAgreementGuardProps> = ({ children }) => {  
  const {
    showModal,
    loading,
    hasChecked,
    handleAgree,
    handleDecline,
  } = useTermsAgreementGuard();

  // 読み込み中の場合は何も表示しない（または読み込み画面）
  if (loading || !hasChecked) {
    return (
      <div className="terms-guard-loading">
        <div className="terms-guard-loading-spinner" />
        <p className="terms-guard-loading-text">
          アプリケーションを初期化中...
        </p>
      </div>
    );
  }

  return (
    <>
      {children}
      <TermsAgreementModal
        isOpen={showModal}
        onAgree={handleAgree}
        onDecline={handleDecline}
      />
    </>
  );
};